export const navEn = {
  'nav-dashboard-link': 'Dashboard',
  'nav-transfers-link': 'Transfers',
  'nav-profile-link': 'My Profile',
  'nav-about-link': 'About My Card',
  'nav-knowledge-base-link': 'Knowledge Base',
  'nav-tax-documents-link': 'Tax Documents',
  'nav-logout-button': 'Logout',
  'nav-open-menu-button': 'Open menu',
  'nav-close-menu-button': 'Close menu'
};

export const navFr = {
  'nav-dashboard-link': 'Mon Compte',
  'nav-transfers-link': 'Transferts',
  'nav-profile-link': 'Mon Profil',
  'nav-about-link': 'À Propos de ma carte',
  'nav-knowledge-base-link': 'Base de Connaissances',
  'nav-tax-documents-link': 'Documents fiscaux',
  'nav-logout-button': 'Fermer ma session',
  'nav-open-menu-button': 'Ouvrir le menu',
  'nav-close-menu-button': 'Fermer le menu'
};
